module.exports = __webpack_public_path__ + "static/media/person.ccd01800.svg";